import { Container, Graphics, Text, TextStyle } from 'pixi.js';
import { COLORS } from '@/config/colors';
import { HUD } from '@/config/hud';
import { UI_FONT } from './widgets';

const BB = HUD.bossBar;

/**
 * Boss / wave bar at the top band (docs/06). The frame redraws only when the
 * band geometry changes; the fill is a pre-drawn bar scaled per frame.
 */
export class BossBar {
  readonly view = new Container();
  private readonly bg = new Graphics();
  private readonly fill = new Graphics();
  private readonly name: Text;
  private geomX = NaN;
  private geomW = NaN;
  private geomY = NaN;
  private lastName = '';

  constructor() {
    this.name = new Text({
      text: '',
      style: new TextStyle({ fontFamily: UI_FONT, fontSize: 18, fill: 0xffffff, letterSpacing: 4 }),
    });
    this.name.anchor.set(0.5, 1);
    this.fill.tint = COLORS.dangerRed;
    this.view.addChild(this.bg, this.fill, this.name);
    this.view.visible = false;
  }

  /** null name hides the bar. bandX/bandW = top band centre + usable width. */
  set(name: string | null, pct: number, screenW: number, bandX: number, bandW: number, y: number): void {
    this.view.visible = name !== null;
    if (!name) return;
    const w = Math.min(BB.maxW, screenW * BB.widthPct, bandW);
    const x = bandX - w / 2;
    if (x !== this.geomX || w !== this.geomW || y !== this.geomY) {
      this.geomX = x;
      this.geomW = w;
      this.geomY = y;
      this.bg.clear().roundRect(x, y, w, BB.h, BB.h / 2).fill(0x221c30)
        .stroke({ color: COLORS.outline, width: 3 });
      this.fill.clear().roundRect(0, 0, w - 4, BB.h - 4, BB.h / 2 - 2).fill(0xffffff);
      this.fill.position.set(x + 2, y + 2);
      this.name.position.set(bandX, y + BB.nameOffset);
      this.lastName = ''; // re-fit the name to the new width
    }
    this.fill.visible = pct > 0;
    this.fill.scale.x = Math.max(10 / Math.max(1, w - 4), Math.min(1, pct));
    if (name !== this.lastName) {
      this.lastName = name;
      this.name.text = name;
      this.name.scale.set(1);
      if (this.name.width > bandW) this.name.scale.set(bandW / this.name.width);
    }
  }
}
